<div *ngIf="shouldShowNotification() && hasAtLeastAdvisorRole$" class="notification notification-warning text--input-small flex--row spacing--margin-none-top">
  <mat-icon class="flex--align-self-center">warning</mat-icon>
  <div>{{ 'cart.cart-notification-LowPrice' | translate }}</div>
</div>
